import {Box} from "@mui/material";
import React from "react";

interface CustomDialogProps {
  children: React.ReactNode;
}

export const CustomDialog = ({ children }: CustomDialogProps) => (
  <Box className="p-8 flex flex-col items-center justify-center text-center space-y-4 min-w-[200px]">
    {children}
  </Box>
)
